export default {"src":"/_next/static/media/calendar.ba55aa5d.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};